import React, { RefObject } from 'react';

import { Box, Spinner } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { DeliveryAddressSelectHandle } from './delivery-addresses';
import { ButtonContainer } from './delivery-addresses/styled';
import { DeliveryAddressFormHandle } from './new-address-form';
import { DeliveryAddressFormFooter } from './new-address-form/delivery-address-form-footer';
import { DeliverHereButton } from './styled';
import { ActionStatus } from './types';

type DeliveryAddressesButtonsProps = {
  status: ActionStatus;
  selected: string;
  selectRef: RefObject<DeliveryAddressSelectHandle | null>;
};
const DeliveryAddressesButtons = ({
  selectRef,
  status,
  selected,
}: DeliveryAddressesButtonsProps) => {
  const isLoading = status === ActionStatus.PENDING;

  const handleOnDeliveryHereButton = () => {
    selectRef.current?.onSelectAddress();
  };

  return (
    <ButtonContainer>
      <DeliverHereButton
        testID="select-delivery-address"
        disabled={isLoading || selected === ''}
        onPress={handleOnDeliveryHereButton}
        bg={isLoading || selected === '' ? primitive.bk.$fieryRedOpacity30 : undefined}
        _text={{
          color: isLoading ? primitive.bk.$bbqBrown : primitive.bk.$white,
        }}
        rightIcon={
          isLoading ? (
            <Box width="$4" height="$4" justifyContent="center" alignItems="center">
              <Spinner size="sm" color={primitive.bk.$white} />
            </Box>
          ) : undefined
        }
      >
        {t('deliverHere')}
      </DeliverHereButton>
    </ButtonContainer>
  );
};

type ModalFooterProps = DeliveryAddressesButtonsProps & {
  formRef: RefObject<DeliveryAddressFormHandle | null>;
  showTermsView: boolean;
  showDeliveryAddresses: boolean;
  createAddressView: boolean;
  isEditing: boolean;
  isDisabled: boolean;
  showTermsLink: boolean;
};
export const ModalFooter = ({
  formRef,
  status,
  showTermsView,
  selectRef,
  selected,
  showDeliveryAddresses,
  createAddressView,
  isEditing,
  isDisabled,
  showTermsLink,
}: ModalFooterProps) => {
  if (status === ActionStatus.QUOTE_UNAVAILABLE || showTermsView) {
    return null;
  }

  if (!createAddressView && showDeliveryAddresses) {
    return <DeliveryAddressesButtons status={status} selectRef={selectRef} selected={selected} />;
  }

  return (
    <DeliveryAddressFormFooter
      isEditing={isEditing}
      submitAddress={() => formRef.current?.handleSubmit()}
      isDisabled={isDisabled}
      isLoading={status === ActionStatus.PENDING}
      showtermsLink={showTermsLink}
    />
  );
};
